module.exports = __webpack_public_path__ + "static/media/preview_general_campaign_3.de783039.svg";